module.exports = __webpack_public_path__ + "img/right_leaf.a0822fd2.png";